module.exports = __webpack_public_path__ + "81a3216041312df05161e3250f6dbceb.pdf";